// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1024px","white":"#ffffff","whiteSmoke":"#f1f1f1","whiteFog":"#f9f9f9","whiteGrey":"#d8d8d8","black":"#000000","grey":"#87848e","lightGrey":"#ccc","primary":"#232323","secondary":"#4a81cc","tertiary":"#4a81cc","quaternary":"#4a81cc","error":"#e32438","success":"#3885141a","inactive":"#4a4a4a","billPrimary":"#4a81cc","linkFocusColor":"#232323"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/home/MeaCarouselComponent.scss
// module id = 1317
// module chunks = 0